import React from 'react'
import { Popover, MenuItem } from '@material-ui/core'

const SectionPopover = props => {
  const { openPopup, handleClosePopup, itemData } = props
  return (
    <Popover
      open={Boolean(openPopup)}
      anchorEl={openPopup}
      onClose={handleClosePopup}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      sx={{
        width: 'auto',
        '& .MuiMenuItem-root': {
          px: 1,
          typography: 'body2',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          margin: '6px',
        },
      }}
      disabledArrow
    >
      {itemData.map((item, index) => (
        <MenuItem
          key={index}
          onClick={e => {
            e.stopPropagation() // Add this line
            item.action()
            handleClosePopup()
          }}
        >
          {item.text}
        </MenuItem>
      ))}
    </Popover>
  )
}

export default SectionPopover
